import { render, staticRenderFns } from "./FirstLoad.vue?vue&type=template&id=4bf7131c&scoped=true&"
import script from "./FirstLoad.vue?vue&type=script&lang=ts&"
export * from "./FirstLoad.vue?vue&type=script&lang=ts&"
import style0 from "./FirstLoad.vue?vue&type=style&index=0&id=4bf7131c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf7131c",
  null
  
)

export default component.exports